import { CreateContractInput, CreateRentChargeInput, LeaseTermOption } from "@/graphql/generated";

type ActionsTypes =
  { type: 'CREATE_CONTRACT-setUnities'; payload: { unitiesIds: string[] } }
  | { type: 'CREATE_CONTRACT-setLeaseTerm'; payload: { startDate: Date, finishDate: Date | null, leaseTermOption: LeaseTermOption } }
  | { type: 'CREATE_CONTRACT-setTenant'; payload: { tenantId: string } }
  | { type: 'CREATE_CONTRACT-setRentCharges'; payload: { rentCharges: CreateRentChargeInput[] } }
  | { type: 'CREATE_CONTRACT-setSecurityDeposit'; payload: { amount: number, receivedDate?: Date } }
  | { type: 'CREATE_CONTRACT-setSigned'; payload: { isSigned: boolean } }
  | { type: 'CREATE_CONTRACT-setLateFees'; payload: { lateFeeDays?: number, percentageOfRentFees?: number, fiatAmountFees?: number } }
  | { type: 'CREATE_CONTRACT-setProperty'; payload: { propertyId: string } }
  | { type: 'CREATE_CONTRACT-setDayForExecuteCharge'; payload: { day: string } }
  | { type: 'CREATE_CONTRACT-setAutoGenerateRentCharge'; payload: { isAutoGenerateRentCharge: boolean } }
  | { type: 'CREATE_CONTRACT-setMonthlyChargeAmount'; payload: { monthlyChargeAmount: string } }

export const CreateContractReducer = (state: CreateContractInput, action: ActionsTypes): CreateContractInput => {
  switch (action.type) {
    case 'CREATE_CONTRACT-setUnities':
      return {
        ...state,
        unitiesIds: action.payload.unitiesIds,
      }

    case 'CREATE_CONTRACT-setLeaseTerm':
      return {
        ...state,
        startDate: action.payload.startDate,
        finishDate: action.payload.finishDate,
        leaseTermOption: action.payload.leaseTermOption,
      }

    case 'CREATE_CONTRACT-setTenant':
      return {
        ...state,
        tenantId: action.payload.tenantId,
      }

    case 'CREATE_CONTRACT-setRentCharges':
      return {
        ...state,
        rentCharges: action.payload.rentCharges,
      }

    case 'CREATE_CONTRACT-setSecurityDeposit':
      return {
        ...state,
        depositAmount: action.payload.amount,
        depositReceivedDate: action.payload.receivedDate,
      }

    case 'CREATE_CONTRACT-setSigned':
      return {
        ...state,
        signed: action.payload.isSigned,
      }

    case 'CREATE_CONTRACT-setLateFees':
      return {
        ...state,
        fiatAmountFees: action.payload.fiatAmountFees,
        percentageOfRentFees: action.payload.percentageOfRentFees,
        lateFeeDays: action.payload.lateFeeDays,
      }

    case 'CREATE_CONTRACT-setProperty':
      return {
        ...state,
        propertyId: action.payload.propertyId,
      }

    case 'CREATE_CONTRACT-setDayForExecuteCharge':
      return {
        ...state,
        dayForExecuteCharges: action.payload.day,
      }

    case 'CREATE_CONTRACT-setAutoGenerateRentCharge':
      return {
        ...state,
        isAutoGenerateRentCharge: action.payload.isAutoGenerateRentCharge,
      }

    case 'CREATE_CONTRACT-setMonthlyChargeAmount':
      return {
        ...state,
        monthlyChargeAmount: action.payload.monthlyChargeAmount,
      }

    default:
      return state
  }
}